import React, { useEffect } from 'react';
import MyNavbar from '../../../components/user/general/mynavbar/MyNavbar.js';
import CategoryBanner from '../../../subscreens/users/Equipmentcategory/Categorybanner/CategoryBanner.js';
import CategoryList from '../../../subscreens/users/Equipmentcategory/Categorylist/CategoryList.js';
import Footer from '../../../components/user/general/footer/Footer.js';
import { scrollToTop } from './../../../helpers/CustomHelper';
const Rent =()=>{
    // useEffect(()=>{
    //     scrollToTop();
    // },[])
    return(
        <>
        <MyNavbar />
        <CategoryBanner />
        <CategoryList />
        <Footer />
        </>
    );
}

export default Rent;